export enum LayoutMode {
    Mobile,
    DesktopMinimized,
    DesktopExpanded,
}